import React from "react"
import "./style.scss"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function ServiceCard({ image, heading, detail, link }) {
  return (
    <div className="col-12 col-sm-6 col-md-4">
      <div
        className="serviceCard card my-3 border-0"
        id={heading.split(" ").join("_").toLowerCase()}
      >
        <img loading="lazy" 
          src={image}
          className="card-img-top img-fluid"
          alt="services_web"
        />
        <div className="card-body pb-4">
          <h5 className="card-title text-purple fs-3 py-1">{heading}</h5>
          <p className="card-text" style={{ textAlign: "justify" }}>
            {detail}
          </p>
          <AniLink
            paintDrip
            hex="#551864"
            to={link}
            className="btn btn-primary px-4"
            style={{ letterSpacing: "2px" }}
          >
            Learn more
          </AniLink>
        </div>
      </div>
    </div>
  )
}

export default ServiceCard
